import FJITIIcon from '../../assets/svg/menu/image-to-image.svg?react';
import FJPEIcon from '../../assets/svg/menu/photo-editor.svg?react';
import FJTTIIcon from '../../assets/svg/menu/text-to-image.svg?react';

import FJITIActiveIcon from '../../assets/svg/menu/image-to-image-active.svg?react';
import FJPEActiveIcon from '../../assets/svg/menu/photo-editor-active.svg?react';
import FJTTIActiveIcon from '../../assets/svg/menu/text-to-image-active.svg?react';

import FJAppConstant from '../../constants/FJAppConstant.js';
import { RELEASE } from '../../constants/FJEvnConstant.js';

const environment = import.meta.env.MODE;
const isRelease = environment !== RELEASE;

export const AI_GENERATOR_PHOTO_TAB_LIST = [
    {
        text: 'ai-image-to-image-menu',
        name: 'ai-image-to-image',
        value: FJAppConstant.IMAGE_TO_IMAGE,
        icon: FJITIIcon,
        hoverIcon: FJITIActiveIcon,
        href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
    },
    {
        text: 'ai-text-to-image-menu',
        name: 'ai-text-to-image',
        value: FJAppConstant.TEXT_TO_IMAGE,
        icon: FJPEIcon,
        hoverIcon: FJPEActiveIcon,
        href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
    },
    {
        text: 'ai-photo-editor-menu',
        name: 'ai-photo-editor',
        value: FJAppConstant.AI_PHOTO_EDITOR,
        icon: FJTTIIcon,
        hoverIcon: FJTTIActiveIcon,
        href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
    },
];
